import { getDefaultValue as getDefaultValueFactory, getInitialValue } from '../_utils'

const defaultStateValues = {
  isOpen: false
}

export const getDefaultValue = (props: Record<string, any>, propKey: string) =>
  getDefaultValueFactory(props, propKey, defaultStateValues)

export const getInitialState = (props: Record<string, any>) => {
  const isOpen = getInitialValue(props, 'isOpen', defaultStateValues)

  return {
    isOpen
  }
}
